import { APP_INITIALIZER, inject, Provider } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs";
import { GoogleAnalyticsService } from "../services/google-analytics.service";


function initGA(ga: GoogleAnalyticsService) {
  return () => ga.init();
}

export const providerGoogleAnalytics: Provider = {
  provide: APP_INITIALIZER,
  multi: true,
  useFactory: () => initGA(inject(GoogleAnalyticsService))
}

export const providerGoogleAnalyticsTracker: Provider = {
  provide: 'googleAnalyticsTracker',
  useFactory: () => {
    const router = inject(Router);
    const ga = inject(GoogleAnalyticsService);

    ga.sendPageView(router.url);
    router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd)
    ).subscribe(e => ga.sendPageView(e.urlAfterRedirects));
  },
  deps: [Router]
}
